import { useMediaQuery, useTheme } from '@mui/material';
import BrandLinearProgress from './BrandLinearProgress';

import styles from './CompanyProgressBar.module.css';

/**
 *	Company Logo with color branded Linear Progress bar underneath for infinite loading display
 */
export default function CompanyProgressBar() {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<div className={styles.root}>
			<div>
				<img
					className={styles.image}
					src={isMobile ? '/Company-Logo.png' : '/Company-Logo-X-Large.png'}
					alt='Company/Brand Logo'
				/>
				<div className={styles.progess}>
					<BrandLinearProgress />
				</div>
			</div>
		</div>
	);
}
